module.exports = __webpack_public_path__ + "static/media/miniPrinter.df1e7a9b.jpg";